import type { ReactNode } from 'react';
import { useIsRestoring } from '@tanstack/react-query';

interface Props {
  readonly children: ReactNode;
  readonly fallback?: ReactNode;
}

export const PersistGate = ({ children, fallback = null }: Readonly<Props>) => {
  const isRestoring = useIsRestoring();

  return isRestoring ? fallback : children;
};
